import { FaCheckCircle } from "react-icons/fa";
import Popover from "../ui/Popover";
import { useState, useEffect } from "react";

// Dummy font data
const fonts = [
  { id: 1, name: 'Arial', value: 'Arial' },
  // { id: 2, name: 'Times New Roman', value: 'Times New Roman' },
  // { id: 3, name: 'Helvetica', value: 'Helvetica' },
  // { id: 4, name: 'Roboto', value: 'Roboto' },
  // { id: 5, name: 'Open Sans', value: 'Open Sans' },
  { id: 2, name: 'Courier', value: 'Courier' },
  { id: 3, name: 'Courier New', value: 'Courier New' },
  { id: 4, name: 'Georgia', value: 'Georgia' },
  { id: 5, name: 'Arial Light', value: 'Arial Light' },
];

function FontSelector({ selectedFont = fonts[0], setSelectedFont, onFontChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (font) => {
    setSelectedFont(font);
    onFontChange(font);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedFont(selectedFont);
    }
  }, [isOpen, selectedFont]);

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      label="Font"
      onSelect={handleSelect}
      width="280px"
    >
      <div className="p-4">
        <div className="max-h-[50vh] overflow-y-auto">
          {fonts.map((font) => (
            <div
              key={font.id}
              onClick={() => handleSelect(font)}
              className="flex items-center gap-4 p-3 hover:bg-gray-50 cursor-pointer border-b"
            >
              <span 
                className="flex-1" 
                style={{ fontFamily: font.value }}
              >
                {font.name}
              </span>
              {selectedFont?.id === font.id && (
                <FaCheckCircle className="h-5 w-5 text-[#1f36c7]" />
              )}
            </div>
          ))}
        </div>
      </div>
    </Popover>
  );
}

export default FontSelector;